import { render, staticRenderFns } from "./pudo-expiry-action-modal.vue?vue&type=template&id=461ecc54"
import script from "./pudo-expiry-action-modal.vue?vue&type=script&lang=js"
export * from "./pudo-expiry-action-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports